// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1J7UhSC0zq2kDW {\n  color: #42526E !important;\n}\n._1J7UhSC0zq2kDW:hover {\n  color: #172B4D !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"closeButton": "_1J7UhSC0zq2kDW"
};
export default ___CSS_LOADER_EXPORT___;
